<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-button type="success" icon="el-icon-plus" @click="handlePcAdd"
            >添加配置</el-button
          >
        </div>
        <el-table
          height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="档位" prop="phase" width="140" align="center" />
          <el-table-column label="所需流水" prop="cost_price" width="180" align="center" />
          <el-table-column label="赠送钻石" prop="amount" width="180" align="center" />
          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />
          <!-- 操作列 -->
          <el-table-column
            label="操作"
            fixed="right"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handlePcEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click.stop="handlePcDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>
        <!-- PC 添加/编辑弹窗 -->
        <el-dialog
          :title="pcDialogType == 'add' ? '添加流水达标奖励配置' : '编辑流水达标奖励配置'"
          :visible.sync="pcDialogVisible"
          width="500px"
          @close="pcResetForm"
          append-to-body
        >
          <el-form
            :model="pcForm"
            :rules="addRules"
            ref="pcFormRef"
            label-width="110px"
          >
            <el-form-item label="档位" prop="phase">
              <el-input
                v-model.number="pcForm.phase"
                placeholder="请输入档位"
                style="width: 300px"
              />
            </el-form-item>
            <el-form-item label="所需流水" prop="cost_price">
              <el-input
                v-model.number="pcForm.cost_price"
                placeholder="请输入所需流水"
                style="width: 300px"
              />
            </el-form-item>
            <el-form-item label="赠送钻石" prop="amount">
              <el-input
                v-model.number="pcForm.amount"
                placeholder="请输入赠送钻石数量"
                style="width: 300px"
              />
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="pcDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcSubmitForm">确认提交</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <div class="mobile-search-group">
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="success"
              plain
              round
              @click="handleMobileAdd"
              style="flex: 1"
              >添加配置</el-button
            >
          </div>
        </div>
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
          >
            <div class="card-header">
              <div class="info">
                <div class="title">档位：{{ item.phase }}</div>
                <div class="meta">
                  ID:{{ item.id }}
                </div>
              </div>
            </div>
            <div class="card-body">
              <div>所需流水：{{ item.cost_price }}</div>
              <div>赠送钻石：{{ item.amount }}</div>
              <div>创建时间：{{ item.created_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="handleMobileEdit(item)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                plain
                round
                @click.stop="handleMobileDelete(item)"
                >删除</el-button
              >
            </div>
          </div>
        </div>
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
          />
        </div>
        <!-- 移动端添加/编辑 -->
        <el-dialog
          :title="mobileDialogType == 'add' ? '添加流水达标奖励配置' : '编辑流水达标奖励配置'"
          :visible.sync="mobileDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileForm"
            :rules="addRules"
            ref="mobileFormRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="档位" prop="phase">
              <el-input
                v-model.number="mobileForm.phase"
                placeholder="档位"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="所需流水" prop="cost_price">
              <el-input
                v-model.number="mobileForm.cost_price"
                placeholder="所需流水"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="赠送钻石" prop="amount">
              <el-input
                v-model.number="mobileForm.amount"
                placeholder="赠送钻石"
                size="medium"
              />
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="mobileDialogVisible = false">取消</el-button>
            <el-button type="primary" size="medium" @click="mobileSubmitForm">保存</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "FlowRewardPanel",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: {
        page: 1,
        page_size: 10,
      },
      // 表单验证
      addRules: {
        phase: [
          { required: true, message: "档位", trigger: "blur" },
          { type: "number", message: "档位必须为数字" }
        ],
        cost_price: [
          { required: true, message: "请输入所需流水", trigger: "blur" },
          { type: "number", message: "流水必须为数字" }
        ],
        amount: [
          { required: true, message: "请输入赠送钻石", trigger: "blur" },
          { type: "number", message: "钻石必须为数字" }
        ],
      },
      // PC
      pcDialogVisible: false,
      pcDialogType: "add",
      pcForm: {
        flow_id: "",
        phase: "",
        cost_price: "",
        amount: "",
      },
      // 移动端
      mobileDialogVisible: false,
      mobileDialogType: "add",
      mobileForm: {
        flow_id: "",
        phase: "",
        cost_price: "",
        amount: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // ==================== 列表 ====================
    getList() {
      this.loading = true;
      api.flow
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // ==================== PC ====================
    handlePcAdd() {
      this.pcDialogType = "add";
      this.pcResetForm();
      this.pcDialogVisible = true;
    },
    handlePcEdit(row) {
      this.pcDialogType = "edit";
      this.pcForm = {
        flow_id: row.id,
        phase: row.phase,
        cost_price: row.cost_price,
        amount: row.amount,
      };
      this.pcDialogVisible = true;
    },
    async handlePcDelete(row) {
      await this.$confirm("此操作将永久删除该配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(() => {
        this.$message.info("已取消删除");
        return Promise.reject();
      });
      this.loading = true;
      api.flow.del({ flow_id: row.id })
        .then(res => {
          if (res.data.code == 1000) {
            this.getList();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    pcResetForm() {
      this.pcForm = {
        flow_id: "",
        phase: "",
        cost_price: "",
        amount: "",
      };
      this.$nextTick(() => {
        if (this.$refs.pcFormRef) this.$refs.pcFormRef.clearValidate();
      });
    },
    pcSubmitForm() {
      this.$refs.pcFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;

        let fn;
        if (this.pcDialogType == "add") {
          fn = api.flow.add;
        } else {
          fn = api.flow.edit;
        }

        fn(this.pcForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.pcDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    // ==================== 移动端 ====================
    handleMobileAdd() {
      this.mobileDialogType = "add";
      this.mobileResetForm();
      this.mobileDialogVisible = true;
    },
    handleMobileEdit(row) {
      this.mobileDialogType = "edit";
      this.mobileForm = {
        flow_id: row.id,
        phase: row.phase,
        cost_price: row.cost_price,
        amount: row.amount,
      };
      this.mobileDialogVisible = true;
    },
    async handleMobileDelete(row) {
      await this.$confirm("此操作将永久删除该配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(() => {
        this.$message.info("已取消删除");
        return Promise.reject();
      });
      this.loading = true;
      api.flow.del({ flow_id: row.id })
        .then(res => {
          if (res.data.code == 1000) {
            this.getList();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    mobileResetForm() {
      this.mobileForm = {
        flow_id: "",
        phase: "",
        cost_price: "",
        amount: "",
      };
      this.$nextTick(() => {
        if (this.$refs.mobileFormRef) this.$refs.mobileFormRef.clearValidate();
      });
    },
    mobileSubmitForm() {
      this.$refs.mobileFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;

        let fn;
        if (this.mobileDialogType == "add") {
          fn = api.flow.add;
        } else {
          fn = api.flow.edit;
        }

        fn(this.mobileForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.mobileDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    // ==================== 公共分页 ====================
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
/* PC */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
/* 移动端 */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/signPanel/flowReward.vue